import { EmailInput, useDonationFormContext } from '@web/components/page-components/DonationForm'

type DonationFormEmailInputProps = {
  hideLabel?: boolean
}

const DonationFormEmailInput = ({ hideLabel }: DonationFormEmailInputProps) => {
  const extraFields = useDonationFormContext((state) => state.formValues.extraFields ?? {})
  const { email } = extraFields
  const actions = useDonationFormContext((state) => state.actions)
  const { setFormValues, updateErrors } = actions

  const updateEmail = (email: string) => {
    setFormValues({ extraFields: { ...extraFields, email } })
    updateErrors({ email: null })
  }

  return (
    <EmailInput
      id="donation-form-email"
      label="Email"
      name="email"
      type="email"
      required={!hideLabel}
      hideLabel={hideLabel}
      value={email ?? ''}
      onChange={(e) => updateEmail(e.target.value)}
    />
  )
}

export default DonationFormEmailInput
